import type { ReactNode } from 'react';
import {
    TbActivity,
    TbArchive,
    TbDownload,
    TbGitBranch,
    TbLink,
    TbMessageCircle,
    TbPencil,
    TbPlus,
    TbRefresh,
    TbTrash,
    TbUserCog,
    TbUserMinus,
    TbUserPlus,
} from 'react-icons/tb';

import type { ResourceActivity } from '@/types';
import { ResourceActivityEventType } from '@/types';

const iconStyle = { display: 'block' } as const;

const resourceActivityIcon = (
    activity: Pick<ResourceActivity, 'eventType'>,
    size: number | string = '1rem',
): ReactNode => {
    const iconMap = {
        [ResourceActivityEventType.ARCHIVED]: <TbArchive size={size} style={iconStyle} />,
        [ResourceActivityEventType.COMMENTED]: <TbMessageCircle size={size} style={iconStyle} />,
        [ResourceActivityEventType.COLLABORATOR_ADDED]: <TbUserPlus size={size} style={iconStyle} />,
        [ResourceActivityEventType.COLLABORATOR_REMOVED]: <TbUserMinus size={size} style={iconStyle} />,
        [ResourceActivityEventType.COLLABORATOR_UPDATED]: <TbUserCog size={size} style={iconStyle} />,
        [ResourceActivityEventType.CREATED]: <TbPlus size={size} style={iconStyle} />,
        [ResourceActivityEventType.DELETED]: <TbTrash size={size} style={iconStyle} />,
        [ResourceActivityEventType.EXPORTED]: <TbDownload size={size} style={iconStyle} />,
        [ResourceActivityEventType.IMPORTED]: <TbDownload size={size} style={iconStyle} />,
        [ResourceActivityEventType.LINKED]: <TbLink size={size} style={iconStyle} />,
        [ResourceActivityEventType.MOVED]: <TbGitBranch size={size} style={iconStyle} />,
        [ResourceActivityEventType.RESTORED]: <TbRefresh size={size} style={iconStyle} />,
        [ResourceActivityEventType.UPDATED]: <TbPencil size={size} style={iconStyle} />,
        [ResourceActivityEventType.VERSION_CREATED]: <TbGitBranch size={size} style={iconStyle} />,
    } as Record<ResourceActivityEventType, ReactNode>;

    return iconMap[activity.eventType] ?? <TbActivity size={size} style={iconStyle} />;
};

export { resourceActivityIcon };
